import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";
import {
  QUERY_TV_ENERGY_DATA,
  SUBSCRIBE_TV_ENERGY_DATA,
  QUERY_TV_ENERGY_CONNECTION_STATE,
  SUBSCRIBE_TV_ENERGY_CONNECTION_STATE,
  START_TV_ENERGY_STREAM,
  STOP_TV_ENERGY_STREAM,
  SUBSCRIBE_RESET_TV_ENERGY_DATA,
} from "../queries/TVEnergyQueries";

import { useDispatch } from "react-redux";
import {
  setConnectionState,
  setTvEnergyData,
  setDriverEnergy,
  resetTvEnergyData,
} from "../../../state/tvEnergyReducer";

export function MutateStartTvEnergyStream() {
  const [startTvEnergyStream] = useMutation(START_TV_ENERGY_STREAM);
  return startTvEnergyStream;
}

export function MutateStopTvEnergyStream() {
  const [stopTvEnergyStream] = useMutation(STOP_TV_ENERGY_STREAM);
  return stopTvEnergyStream;
}

export function QueryTVEnergyData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_TV_ENERGY_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setTvEnergyData(data.getTvEnergyData));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryTVEnergyConnectionState() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_TV_ENERGY_CONNECTION_STATE);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setConnectionState(data.getTvEnergyConnectionState));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeTVEnergyData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_TV_ENERGY_DATA, {
    onData: (x) => {
      const tvEnergyUpdate = x.data.data.newTvEnergyData;
      dispatch(setDriverEnergy(tvEnergyUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeTVEnergyConnectionState() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_TV_ENERGY_CONNECTION_STATE, {
    onData: (x) => {
      const connectionState = x.data.data.newTvEnergyConnectionState;
      dispatch(setConnectionState(connectionState));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeResetTvEnergyData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_RESET_TV_ENERGY_DATA, {
    onData: (_) => {
      dispatch(resetTvEnergyData());
    },
  });
  if (error) {
    console.log(error);
  }
}
